export type AvatarContext = 'admin' | 'candidate' | 'other';
export type AvatarType = 'image' | 'initials' | 'icon' | 'image-with-container' | 'custom';
export type AvatarSize =
  | 'small-x'
  | 'top-nav-company-selector'
  | 'small'
  | 'nav-item'
  | 'base'
  | 'medium'
  | 'large';
export type AvatarShape = 'oval' | 'square';
export type AvatarFontSize = 'default' | 'small';

export enum AvatarRsvpBadge {
  Accepted = 'accepted',
  Declined = 'declined',
  NeedsAction = 'needs_action',
  Tentative = 'tentative',
}
